import {useActivateApiAbTestCallback} from '@aboutyou/feature-flags';
import {useIsInitialLocation} from '@aboutyou/router';
import {useEffect} from 'react';

export const useActivatePPIAbTest = () => {
  const isInitialLocation = useIsInitialLocation();
  const activateAbTest = useActivateApiAbTestCallback();

  /**
   * Do not activate the A/B test on the initial page as the personalized product injections do not happen there.
   *
   * Check useLastSeenProductsRequestParameter for more context.
   */
  useEffect(() => {
    if (isInitialLocation) {
      return;
    }
    activateAbTest('ab_personalized_product_injections_1');
  }, [activateAbTest, isInitialLocation]);
};
